import { PartConfiguratorTopLevelView } from "src/components/views/erp/configurator/configuratorForm/PartConfiguratorTopLevelView.tsx";
import { ConfigurationCreationApi } from "src/api/generated/erp/configurator/api/configurationCreationApi";
import { UnsavedCustomerOrderLinePartConfiguratorType } from "src/api/generated/erp/configurator/configuratorType/impl/unsavedCustomerOrderLinePartConfiguratorType.ts";
import { FormResult } from "src/components/common/forms/types.ts";
import { DataDirtyStateChangeHandler } from "src/utils/dataDirtyStateChangeHandler.ts";

export interface CustomerOrderLineBeforeCreateConfiguratorViewProps {
	configuratorType: UnsavedCustomerOrderLinePartConfiguratorType;
	onCompleted: (result: FormResult<number>) => void;
	onDataDirtyStateChanged?: DataDirtyStateChangeHandler;
}

export const CustomerOrderLineBeforeCreateConfiguratorView = ({
	configuratorType,
	onCompleted,
	onDataDirtyStateChanged,
}: CustomerOrderLineBeforeCreateConfiguratorViewProps) => {
	return (
		<PartConfiguratorTopLevelView
			configuratorType={configuratorType}
			onDataDirtyStateChanged={onDataDirtyStateChanged}
			onCompleted={async (result) => {
				if (result.type === "success") {
					const { propertyValues, propertyInputValues, configurationSessionId } = result.value;
					const partConfigurationId =
						await ConfigurationCreationApi.createPartConfigurationForUnsavedCustomerOrderLine({
							configuratorType: configuratorType,
							propertyValues: propertyValues,
							propertyInputValues: propertyInputValues,
							configurationSessionId: configurationSessionId,
						});
					onCompleted({ type: "success", value: partConfigurationId });
				} else {
					onCompleted(result);
				}
			}}
		/>
	);
};
